import PropTypes from 'prop-types'

export function PhoneField({
  name,
  onChange,
  label,
  value,
  additionalClass,
  isError,
  errorLabel,
  ...props
}) {
  const handleChange = (e) => {
    const numericValue = e.target.value.replace(/[^\d]/g, '')
    if (numericValue !== e.target.value) return // Ignore non-numeric input
    onChange({
      ...e,
      target: { ...e.target, name: e.target.name, value: numericValue.slice(0, 15) },
    })
  }

  return (
    <div className="field">
      {label && (
        <label htmlFor={name} className="label">
          {label}
        </label>
      )}
      <div className="control">
        <input
          type="tel"
          min={0}
          name={name}
          value={value}
          className={`input ${additionalClass || ''} ${isError && 'is-danger'}`}
          onChange={handleChange}
          {...props}
        />
        {errorLabel && isError && <span className={'label--error'}>{errorLabel}</span>}
      </div>
    </div>
  )
}

PhoneField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  additionalClass: PropTypes.string,
  disabled: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  isError: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  errorLabel: PropTypes.string,
}

export default PhoneField
